module.exports = "//cdn.mxpnl.com/static/asset-cache/d165718792a1f0b8907dc1f448feb9cd/iron/common/widgets/demo-selector-modal/assets/icons/eCommerce.svg";